import { request } from './client.js';

// ─── Categories ───────────────────────────────────────────────

export function adminGetCategories() {
  return request('/api/admin/categories');
}

export function adminCreateCategory(data) {
  return request('/api/admin/categories', { method: 'POST', body: data });
}

export function adminUpdateCategory(id, data) {
  return request(`/api/admin/categories/${id}`, { method: 'PUT', body: data });
}

export function adminDeleteCategory(id) {
  return request(`/api/admin/categories/${id}`, { method: 'DELETE' });
}

// ─── Brands ───────────────────────────────────────────────────

export function adminGetBrands() {
  return request('/api/admin/brands');
}

export function adminCreateBrand(data) {
  return request('/api/admin/brands', { method: 'POST', body: data });
}

export function adminUpdateBrand(id, data) {
  return request(`/api/admin/brands/${id}`, { method: 'PUT', body: data });
}

export function adminDeleteBrand(id) {
  return request(`/api/admin/brands/${id}`, { method: 'DELETE' });
}

// ─── Option Types（選項類型 master）───────────────────────────

export function adminGetOptionTypes() {
  return request('/api/admin/option-types');
}

export function adminCreateOptionType(data) {
  return request('/api/admin/option-types', { method: 'POST', body: data });
}

export function adminUpdateOptionType(id, data) {
  return request(`/api/admin/option-types/${id}`, { method: 'PUT', body: data });
}

export function adminDeleteOptionType(id) {
  return request(`/api/admin/option-types/${id}`, { method: 'DELETE' });
}
